import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Sidebar = ({ setLoggedIn }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    setLoggedIn(false);
    navigate('/login');
  };

  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark" style={{ width: '280px', height: '100vh' }}>
      <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
        <i className="fas fa-dumbbell me-2"></i>
        <span className="fs-4">Gym CRM</span>
      </a>
      <hr />
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
          <NavLink to="/" className="nav-link text-white" end>
            <i className="fas fa-tachometer-alt me-2"></i>
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/members" className="nav-link text-white">
            <i className="fas fa-users me-2"></i>
            Members
          </NavLink>
        </li>
        <li>
          <NavLink to="/trainers" className="nav-link text-white">
            <i className="fas fa-user-ninja me-2"></i>
            Trainers
          </NavLink>
        </li>
        <li>
          <NavLink to="/classes" className="nav-link text-white">
            <i className="fas fa-chalkboard-teacher me-2"></i>
            Classes
          </NavLink>
        </li>
        <li>
          <NavLink to="/schedule" className="nav-link text-white">
            <i className="fas fa-calendar-alt me-2"></i>
            Schedule
          </NavLink>
        </li>
        <li>
          <NavLink to="/events" className="nav-link text-white">
            <i className="fas fa-calendar-check me-2"></i>
            Events
          </NavLink>
        </li>
        <li>
          <NavLink to="/workout-templates" className="nav-link text-white">
            <i className="fas fa-clipboard-list me-2"></i>
            Workout Templates
          </NavLink>
        </li>
        <li>
          <NavLink to="/exercise-library" className="nav-link text-white">
            <i className="fas fa-book me-2"></i>
            Exercise Library
          </NavLink>
        </li>
        <li>
          <NavLink to="/attendance" className="nav-link text-white">
            <i className="fas fa-user-check me-2"></i>
            Attendance
          </NavLink>
        </li>
      </ul>
      <hr />
      <div className="dropdown">
        <button className="btn btn-danger w-100" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt me-2"></i>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;